import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import { useFormikContext } from "formik";
import { FC, useCallback, useEffect } from "react";
import {
  ICreateProposalForm,
  ICreateProposalProps,
} from "../../../../../common/interfaces/proposals.interface";

import { clubsStore } from "../../../../../contexts/clubStore";
import WizardField from "../../../../WizardField/WizardField";
import "./RoleVotesConfig.scss";
const RoleVotesConfig: FC<{ formConfig: ICreateProposalProps }> = ({
  formConfig,
}) => {
  const { clubBasicInfo } = clubsStore.getState();
  const { values, setFieldValue } = useFormikContext<ICreateProposalForm>();

  useEffect(() => {
    return () => {
      setFieldValue(formConfig.formFields.roleVotes.name, []);
    };
  }, []);

  const setNewRoleVote = useCallback(
    (currentWeight: number, newWeight: number, role: string) => {
      const roleVotes = [...values.roleVotes];
      const addedRole = roleVotes.findIndex((r) => r.role === role);
      if (addedRole < 0) {
        roleVotes.push({
          currentWeight: currentWeight,
          role: role,
          updateWeight: newWeight,
        });
      } else {
        roleVotes[addedRole] = {
          ...values.roleVotes[addedRole],
          updateWeight: newWeight,
        };
      }

      setFieldValue(formConfig.formFields.roleVotes.name, roleVotes);
    },
    [values]
  );

  return (
    <div className="role-votes-config">
      {clubBasicInfo.roleConfig.map((role, index) => {
        return (
          <div className="role-votes-config__item">
            <p className="role-votes-config__role-name">{role.name}</p>
            <div className="role-votes-config__power">
              <p className="role-votes-config__weight">
                {role.roleWeight / LAMPORTS_PER_SOL} votes
              </p>
              <p className="role-votes-config__label">Current voting power</p>
            </div>
            <WizardField
              name={`roleVotes.${index}.updateWeight`}
              type="number"
              placeholder="Enter new voting power"
              onChange={(e) =>
                setNewRoleVote(
                  role.roleWeight,
                  e.target.value * LAMPORTS_PER_SOL,
                  role.name
                )
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default RoleVotesConfig;
